import { exposeMarketingData } from "@ueni/fe-kit/services/marketingData";
import { LoginResponse } from "@ueni/users-api";
import { useCallback } from "react";
import { REDIRECT_COOKIE } from "../constants/cookie";
import { eventsV2 } from "../constants/eventsV2";
import { acceptCookies, readCookie, writeCookie } from "../services/cookieStorage";
import { sendEvent } from "../utils/analytics/sendEvent";
import { getHubUrl } from "../utils/hubRoutes";
import { useQuery } from "./useQuery";

export const useAfterLogin = () => {
  const query = useQuery();
  const redirect_url = query.get("redirect_url");
  const passToken = query.get("pass_token");

  const afterLogin = useCallback(
    async (data: LoginResponse, label: string) => {
      sendEvent(eventsV2.login.success({ label }));
      const { token, user } = data;
      // const { token, expiration, user } = data;
      exposeMarketingData("user", user as any);
      acceptCookies();
      // writeUserCookie({ auth: { token, expiration }, ...user });
      let redirectUrl = redirect_url;
      if (!redirectUrl) {
        redirectUrl = readCookie(REDIRECT_COOKIE) as string;
      }
      writeCookie(REDIRECT_COOKIE, undefined);
      if (redirectUrl) {
        const url = passToken ? `${redirectUrl}?token=${token}` : redirectUrl;
        return window.location.assign(url);
      }

      window.location.assign(`${getHubUrl(user.locale)}?logged_user=1`);
    },
    [passToken, redirect_url]
  );

  return afterLogin;
};
